import './index.css';

import { Auth0Provider } from '@auth0/auth0-react';
import { ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { apiPlugin, storyblokInit } from '@storyblok/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import App from './App';
import { TenantProvider } from './context/TenantContext';
import store from './stores';
import theme from './theme';

storyblokInit({
  accessToken: process.env.REACT_APP_STORYBLOK_TOKEN || 'UKoPrcuEdISxVx3Hmh5O1gtt',
  use: [apiPlugin],
  bridge: true,
  apiOptions: {
    region: 'us',
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 min fresh
      refetchOnWindowFocus: false, // don’t spam
      refetchOnReconnect: true,
    },
  },
});

const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;
const AUTH0_CLIENTID = process.env.REACT_APP_AUTH0_CLIENTID;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={AUTH0_DOMAIN!}
      clientId={AUTH0_CLIENTID!}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/callback`,
      }}
      cacheLocation="localstorage"
    >
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Provider store={store}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <QueryClientProvider client={queryClient}>
                <TenantProvider>
                  <App />
                </TenantProvider>
              </QueryClientProvider>
            </LocalizationProvider>
          </Provider>
        </BrowserRouter>
      </ThemeProvider>
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
